var map = {
	"./chi-1-back.svg": "a6ef",
	"./chi-1-front.svg": "dd45",
	"./ci-back-chl.svg": "e78f",
	"./ci-front-chl.svg": "95dd",
	"./dni-back.svg": "bc1e",
	"./dni-front.svg": "02b0",
	"./lc-back-chl.svg": "1f64",
	"./lc-back.svg": "0482",
	"./lc-front-chl.svg": "40d8",
	"./lc-front.svg": "ff94",
	"./selfie-front.svg": "3305",
	"./selfie-ilustracion.svg": "fefd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb66";